<!--视频内容-->
<template>
  <div class="main">
    <div class="video" v-on:click="onDownClick()">
      <div class="cover">
        <img :src="`/api/resource/resource/resource/download/${getCoverImage(data.cover,data.resource)}`">
      </div>
      <div class="cover-modal"></div>
      <div class="info">
        <div class="info-content">
          <img src="../../../assets/images/common/player.svg" alt="">
          <p>
            打开足趣社区，看高清视频
          </p>
        </div>
        <div class="info-bottom">
          <span class="info-bottom-desc">{{ format(data.duration) }}</span>
        </div>
      </div>
    </div>
    <div class="open-tips">
      提高三倍流畅度，打开足趣社区
    </div>
    <div class="title">
      {{ data.note }}
    </div>
    <div class="interact-bar">
      <div class="user-info">
        <div class="photo">
          <img
              :src="`/api/resource/resource/resource/download/${data.promulgatorMessage.photo}?imgStyleName=no_watermark_compress`">
        </div>
        <div class="nickname">
          {{ data.promulgatorMessage.nickname }}
        </div>
      </div>
      <div class="opr">
        <div class="opr-item">
          <img src="../../../assets/images/common/message-black.svg" alt="">
          <span v-if="data.commentNumber !== 0">{{ data.commentNumber }}</span>
        </div>
        <div class="opr-item">
          <img src="../../../assets/images/common/like-black.svg" alt="">
          <span v-if="data.likeNumber !== 0">{{ data.likeNumber }}</span>
        </div>
        <div class="opr-item">
          <img src="../../../assets/images/common/view-black.svg" alt="">
          <span v-if="data.readNumber !== 0">{{ data.readNumber }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 下载按钮点击事件
    onDownClick: [Function],
    // 数据内容
    data: [Object],
  },
  methods: {
    // 获得封面图片(有封面就直接用封面，否则用视频转换)
    getCoverImage(cover, resource) {
      return cover ?? (resource + "?imgStyleName=gif");
    },

    // 时间格式化
    format(time) {
      if (time === null) return;
      const push0 = str => str <= 9 ? '0' + str : str;
      return `${push0(parseInt(time / 60 / 60))}:${push0(parseInt(time / 60 % 60))}:${push0(time % (60))} `
    }
  },
}
</script>

<style scoped>
.video {
  height: 210px;
  width: 100%;
  position: relative;
}

.video .cover {
  width: 100%;
  height: 100%;
  position: absolute;
}

.video .cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video .cover-modal {
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.1);
}

.video .info {
  position: absolute;
  height: 100%;
  width: 100%;
  color: #fff;
}

.video .info .info-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.video .info .info-content img {
  width: 30px;
}

.video .info .info-content p {
  margin-top: 10px;
  font-size: 14px;
  text-align: center;
  text-shadow: 0 2px 8px rgba(0, 0, 0, .5);
}

.video .info .info-bottom {
  position: absolute;
  left: 10px;
  font-size: 12px;
  bottom: 10px;
}

.open-tips {
  color: #ff4a2d;
  font-size: 14px;
  height: 35px;
  line-height: 35px;
  background: #f5f5f5;
  text-align: center;
  padding: 0 15px 0 10px;
}

.title {
  font-size: 16px;
  color: #262626;
  letter-spacing: 0;
  line-height: 23px;
  margin: 12px 14px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.interact-bar {
  height: 40px;
  padding: 20px 14px;
  border-bottom: 1px solid hsla(0, 0%, 54.9%, .08);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.user-info {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.user-info .photo {
  width: 36px;
  height: 36px;
  margin-right: 8px;
}

.user-info .photo img {
  width: 36px;
  height: 36px;
  display: block;
  border-radius: 36px;
}

.user-info .nickname {
  font-size: 16px;
  color: #262626;
}

.opr {
  display: flex;
  flex-direction: row;
}

.opr-item {
  height: 24px;
  width: 24px;
  position: relative;
  margin-left: 25px;
}

.opr-item:last-child {
  margin-right: 10px;
}

.opr-item img {
  height: 100%;
  width: 100%;
}

.opr-item span {
  position: absolute;
  left: 19px;
  top: -7px;
  color: #ff4a2d;
  font-size: 10px;
}
</style>
